export default __webpack_public_path__ + "static/media/mlc-finisaje-exterioare.e4d2e6a6.jpeg";